var React = require('react');

function Print (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"print","d":"M241.6,108.4V48.7c0-4.4-1.8-8.7-4.9-11.8l-23.5-23.5c-3.1-3.1-7.4-4.9-11.8-4.9h-143c-9.2,0-16.7,7.5-16.7,16.7\n\tv83.3c-18.4,0-33.3,14.9-33.3,33.3V200c0,4.6,3.7,8.3,8.3,8.3h25v50c0,9.2,7.5,16.7,16.7,16.7H225c9.2,0,16.7-7.5,16.7-16.7v-50h25\n\tc4.6,0,8.3-3.7,8.3-8.3v-58.3C275,123.3,260,108.4,241.6,108.4z M208.3,241.6H75.1v-50h133.2V241.6z M208.3,125.1H75.1V41.8H175v25\n\tc0,4.6,3.7,8.3,8.3,8.3h25V125.1z M233.3,162.5c-6.9,0-12.5-5.6-12.5-12.5c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5\n\tC245.8,157,240.2,162.6,233.3,162.5C233.3,162.6,233.3,162.6,233.3,162.5L233.3,162.5z"}));
}

Print.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = Print;

Print.default = Print;
